import {LocationDefinition} from "../../../../../providers/definitions/LocationDefinitionProvider";

export const emptyLocationDefinition: LocationDefinition = {
    id: "",
    title: "",
    description: "",
    slug: "",
    phone: "",
    address: "",
    imageUrl: ""
};